import { createAction } from "redux-actions";
import { moduleSlug } from "modules/Tracker/services/constants";

export const clearTracks = createAction(`${moduleSlug}/CLEAR_TRACKS`);

export const deleteTracks = createAction(`${moduleSlug}/DELETE_TRACKS`);

export const getTracks = createAction(`${moduleSlug}/GET_TRACKS`);
export const getTracksSuccess = createAction(`${moduleSlug}/GET_TRACKS/SUCCESS`);
export const getTracksError = createAction(`${moduleSlug}/GET_TRACKS/ERROR`);

export const getCountTracks = createAction(`${moduleSlug}/GET_COUNT_TRACKS`);
export const getCountTracksSuccess = createAction(`${moduleSlug}/GET_COUNT_TRACKS/SUCCESS`);
export const getCountTracksError = createAction(`${moduleSlug}/GET_COUNT_TRACKS/ERROR`);

export const setLoadersOnTasks = createAction(`${moduleSlug}/SET_LOADERS_ON_TASK`);

export const setSelectedTrackerTasks = createAction(`${moduleSlug}/SET_SELECTED_TASK`);

export const getTrackerProgressInfo = createAction(`${moduleSlug}/GET_TRACKER_PROGRESS_INFO`);
export const setTrackerProgressInfo = createAction(`${moduleSlug}/SET_TRACKER_PROGRESS_INFO`);

export const setEditMessageDialog = createAction(`${moduleSlug}/SET_EDIT_MESSAGE`);
export const mergeEditMessageDialog = createAction(`${moduleSlug}/MERGE_EDIT_MESSAGE`);

export const setBackDropLoader = createAction(`${moduleSlug}/SET_BACK_DROP_LOADER`);

export const getTrackFullMessage = createAction(`${moduleSlug}/GET_TRACK_FULL_MESSAGE`);
export const setTrackFullMessage = createAction(`${moduleSlug}/SET_TRACK_FULL_MESSAGE`);
